import { uuCompactArrayOrObject } from 'lodash';
import { phonesInitialValues } from 'src/common/form/Profile/EditPhoneNumbers/utils';
import { emailsInitialValues } from 'src/common/form/Profile/EditEmailAddresses/utils';

export default function getInitialValuesFromContact(contact = {}) {
  const phones = phonesInitialValues(contact.phone_numbers);
  const emails = emailsInitialValues(contact.email_addresses);

  // Contact Preferences
  function transformContactPreferences(contactPreferences) {
    const timeslots = {};

    if (contactPreferences?.timeslots) {
      Object.entries(contactPreferences.timeslots).forEach(([day, slots]) => {
        if (slots !== null) {
          timeslots[day] = slots.map(({ start_time, end_time }) => ({
            start_time,
            end_time,
          }));
        }
      });
    }

    return {
      contact_notes: contactPreferences?.contact_notes,
      preferred_contact_methods: contactPreferences?.preferred_contact_methods,
      timeslots,
      voice_mail_ok: contactPreferences?.voice_mail_ok?.toString(),
    };
  }

  const contactPreferencesInitialValues = Object.keys(contact).length > 0 ?
    transformContactPreferences(contact.contact_preference) :
    undefined;

  // Record Languages
  const existingRecordLanguages = contact?.preferred_languages || [];

  const existingSpokenLanguages = existingRecordLanguages
  .filter((item) => item.record_language_type === 'spoken')
  .map((item) => ({
    id: item.language_id,
    code: item.language_code,
    name: item.language_name,
  }));

  const existingWrittenLanguages = existingRecordLanguages
  .filter((item) => item.record_language_type === 'written')
  .map((item) => ({
    id: item.language_id,
    code: item.language_code,
    name: item.language_name,
  }));

  const initialValues = uuCompactArrayOrObject({
    addresses: contact.addresses,
    date_of_birth: contact.date_of_birth,
    email_addresses: emails,
    ethnicity: contact.ethnicity,
    first_name: contact.first_name,
    gender: contact.gender,
    last_name: contact.last_name,
    marital_status: contact.marital_status,
    military: contact.military,
    phone_numbers: phones,
    preferred_communication_method: contact.preferred_communication_method,
    preferred_communication_time_of_day: contact.preferred_communication_time_of_day,
    race: contact.race,
    ssn_last4: contact.ssn_last4,
    ssn: contact.ssn,
    contact_preferences: contactPreferencesInitialValues,
    preferred_spoken_languages: existingSpokenLanguages,
    preferred_written_languages: existingWrittenLanguages,
  });

  return initialValues;
}
